var site = site || {};

// Run all the inits \o/
$(function() {
	if (document.body.classList.contains('viewCar')) {
		const deviceView = document.getElementById('viewDeviceMain');
		if (deviceView) {
			const deviceLabel = document.getElementById('deviceMainLabel');
			const promo = document.getElementById('promo');
			let len = promo ? 30 : 40;
			if (deviceLabel && deviceLabel.innerText) {
				if (deviceLabel.innerText.length > len) {
					deviceLabel.classList.add('deviceLabelLength');
				}
			}
		}
	}
});

moya.usedcars = moya.usedcars || {};
moya.usedcars = $.extend(moya.usedcars, {
	initSubmitButton: function(id) {
		$('#'+id).removeAttr('name');
		$('#elm_searchForm_submit').prepend('<a id="dg_reset" class="clear" href="#" onclick="moya.usedcars.clearForm();return false;">Hreinsa leit</a><br />');
		var $form = $('.usedcars__search').find('#searchForm');
		$form.submit(function() {
			$form.find(':input').each(function(){
				this.disabled = !($(this).val());
			});
			return true;
		});
	},

	search: function() {
		var $bOwner = $('#bOwnerFilter');
		if ($bOwner.length === 1) {
			var $check = $bOwner.find('input[type=checkbox]');
			var $hidden = $('input#owner');
			if ($check.length === 1 && $hidden.length === 1) {
				$check.change(function() {
					$hidden.val(this.checked ? 1 : 0);
					$hidden.parents('form').submit();
				});
				$check.prop('checked', parseInt($hidden.val()) > 0);
			}
		}
	},

	searchFormDefaultLabels:function() {
		$('.elm_select', '#searchForm').each(function() {
			$(this).find('option:first-child').attr('label', '--').text('--');
		});
	}
});
